export const Type = {
  VTSZ: 'VTSZ',
  SZJ: 'SZJ',
};
export const TypeOption = [
  { value: Type.VTSZ, label: 'VTSZ' },
  { value: Type.SZJ, label: 'SZJ' },
];
